// Mock data for Tropiluxe website

export const packages = [
  {
    id: 1,
    name: 'Romantic Escape Package',
    description: 'An intimate beachside dinner for two, perfect for proposals, anniversaries, or romantic celebrations.',
    price: 'From $350',
    image: 'https://customer-assets.emergentagent.com/job_beachdinner-lux/artifacts/9e45bib8_IMG_0995.jpeg',
    inclusions: [
      'Private beachside table setup',
      '3-course gourmet meal',
      'Champagne or wine pairing',
      'Romantic lighting with lanterns',
      'Fresh flower centerpiece',
      'Personal server'
    ],
    addOns: [
      'Fire show performance',
      'Professional photography',
      'Custom menu design',
      'Live acoustic music'
    ]
  },
  {
    id: 2,
    name: 'Birthday Bash Package',
    description: 'Celebrate another year with style on Jamaica\'s beautiful beaches with friends and family.',
    price: 'From $500',
    image: 'https://customer-assets.emergentagent.com/job_beachdinner-lux/artifacts/pmswinmn_IMG_1554.jpeg',
    inclusions: [
      'Decorated beach setup for up to 10 guests',
      'Customizable birthday menu',
      'Birthday cake',
      'Themed decorations',
      'Sound system for music',
      'Dedicated event coordinator'
    ],
    addOns: [
      'Fire show performance',
      'DJ services',
      'Additional guests',
      'Photo booth setup'
    ]
  },
  {
    id: 3,
    name: 'Family Celebration Package',
    description: 'Create lasting memories with your loved ones in a beautiful beachfront setting.',
    price: 'From $650',
    image: 'https://customer-assets.emergentagent.com/job_beachdinner-lux/artifacts/jxcn8d1y_IMG_2199.jpeg',
    inclusions: [
      'Beach setup for up to 15 guests',
      'Family-style buffet dinner',
      'Beverage service',
      'Kid-friendly menu options',
      'Beach games and activities',
      'Professional staff'
    ],
    addOns: [
      'Fire show performance',
      'Beach bonfire',
      'Tropical fruit station',
      'Group photography'
    ]
  },
  {
    id: 4,
    name: 'Themed Event Package',
    description: 'Fully customizable themed dinner experience tailored to your vision and celebration.',
    price: 'From $750',
    image: 'https://customer-assets.emergentagent.com/job_beachdinner-lux/artifacts/aphee29t_IMG_2198.jpeg',
    inclusions: [
      'Custom themed decorations',
      'Specialized menu design',
      'Setup for up to 20 guests',
      'Entertainment coordination',
      'Full event planning support',
      'Professional team'
    ],
    addOns: [
      'Fire show performance',
      'Live band',
      'Custom lighting design',
      'Specialty cocktail bar'
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah & Michael',
    event: 'Anniversary Celebration',
    rating: 5,
    comment: 'Our 10th anniversary dinner was absolutely magical. The attention to detail, the food, and the stunning beach setting made it an unforgettable evening. Thank you Tropiluxe!',
    date: 'March 2024'
  },
  {
    id: 2,
    name: 'Jennifer Thompson',
    event: 'Birthday Party',
    rating: 5,
    comment: 'Tropiluxe made my 40th birthday celebration extraordinary. From the beautiful setup to the delicious food and fire show, everything exceeded our expectations.',
    date: 'February 2024'
  },
  {
    id: 3,
    name: 'David & Lisa Chen',
    event: 'Proposal',
    rating: 5,
    comment: 'I proposed to Lisa on the beach with Tropiluxe\'s help, and she said yes! The romantic setup was perfect, and the team made sure every detail was flawless. Highly recommend!',
    date: 'January 2024'
  },
  {
    id: 4,
    name: 'The Martinez Family',
    event: 'Family Reunion',
    rating: 5,
    comment: 'We had 15 family members and Tropiluxe handled everything perfectly. The food was amazing, the beach setup was beautiful, and the kids had a blast. A night we\'ll never forget!',
    date: 'December 2023'
  }
];

export const galleryImages = [
  {
    id: 1,
    url: 'https://images.pexels.com/photos/13648790/pexels-photo-13648790.jpeg',
    alt: 'Elegant beach table setup with ocean view',
    category: 'setups'
  },
  {
    id: 2,
    url: 'https://images.pexels.com/photos/4765114/pexels-photo-4765114.jpeg',
    alt: 'Romantic beach dining setup',
    category: 'romantic'
  },
  {
    id: 3,
    url: 'https://images.pexels.com/photos/5864499/pexels-photo-5864499.jpeg',
    alt: 'Luxury beach dining at sunset',
    category: 'sunset'
  },
  {
    id: 4,
    url: 'https://images.pexels.com/photos/5864598/pexels-photo-5864598.jpeg',
    alt: 'Intimate sunset dinner setup',
    category: 'romantic'
  },
  {
    id: 5,
    url: 'https://images.pexels.com/photos/3171201/pexels-photo-3171201.jpeg',
    alt: 'Sophisticated dining arrangement',
    category: 'setups'
  },
  {
    id: 6,
    url: 'https://images.pexels.com/photos/6869497/pexels-photo-6869497.jpeg',
    alt: 'Elegant table presentation',
    category: 'setups'
  },
  {
    id: 7,
    url: 'https://images.pexels.com/photos/635279/pexels-photo-635279.jpeg',
    alt: 'Vibrant sunset seascape',
    category: 'sunset'
  },
  {
    id: 8,
    url: 'https://images.pexels.com/photos/561463/pexels-photo-561463.jpeg',
    alt: 'Romantic sunset beach view',
    category: 'sunset'
  },
  {
    id: 9,
    url: 'https://customer-assets.emergentagent.com/job_beachdinner-lux/artifacts/jy79fvql_IMG_0996.jpeg',
    alt: 'Romantic beach canopy setup at sunset with candles',
    category: 'romantic'
  },
  {
    id: 10,
    url: 'https://customer-assets.emergentagent.com/job_beachdinner-lux/artifacts/98cubosa_IMG_1548.jpeg',
    alt: 'Heart-shaped candle arrangement on beach',
    category: 'romantic'
  }
];

export const blogPosts = [
  {
    id: 1,
    title: 'Planning the Perfect Beach Proposal in Jamaica',
    excerpt: 'Everything you need to know to create an unforgettable proposal moment on Jamaica\'s stunning beaches.',
    date: 'March 15, 2024',
    author: 'Tropiluxe Team',
    image: 'https://images.pexels.com/photos/4765114/pexels-photo-4765114.jpeg',
    category: 'Tips & Guides'
  },
  {
    id: 2,
    title: 'Top 5 Jamaican Dishes for Your Beach Dinner',
    excerpt: 'Discover the most popular authentic Jamaican cuisine options that will delight your guests.',
    date: 'March 10, 2024',
    author: 'Chef Marcus',
    image: 'https://images.pexels.com/photos/3171201/pexels-photo-3171201.jpeg',
    category: 'Food & Menu'
  },
  {
    id: 3,
    title: 'Why Beach Dining is Perfect for Celebrations',
    excerpt: 'Explore the unique benefits of hosting your special event on Jamaica\'s beautiful coastline.',
    date: 'March 5, 2024',
    author: 'Tropiluxe Team',
    image: 'https://images.pexels.com/photos/5864499/pexels-photo-5864499.jpeg',
    category: 'Event Planning'
  }
];

export const contactInfo = {
  email: 'tropiluxejamaica@yahoo.com',
  phone: '+1 (876) 555-0123',
  address: 'Montego Bay & Negril, Jamaica',
  locations: [
    { id: 'montego-bay', name: 'Montego Bay' },
    { id: 'negril', name: 'Negril' }
  ],
  socialMedia: {
    instagram: '@tropiluxe',
    facebook: 'TropiluxeJamaica',
    twitter: '@tropiluxe'
  }
};